<template>
    <el-drawer
        title="订单详情"
        :visible.sync="value"
        :direction="direction"
        :custom-class="classNames+ '_wrap'"
        @close="handleClose">
        <div :class="classNames" v-loading="isLoading === 'noFullScreen'">
            <el-scrollbar style="flex: 1" ref="scrollbar">
                <div :class="classNames+ '_content'">
                    <div :class="classNames+ '_content_title'">基本信息</div>
                    <div :class="classNames+ '_content_item'">
                        <div :class="classNames+ '_content_item_label'">订单号</div>
                        <div :class="classNames+ '_content_item_con'">{{detailObj.order_no}}</div>
                    </div>
                    <div :class="classNames+ '_content_item'">
                        <div :class="classNames+ '_content_item_label'">订单状态</div>
                        <div :class="[classNames + '_statur_state',{[classNames+ '_content_item_status_success']: detailObj.status == 4, [classNames+ '_content_item_status_error']:  detailObj.status == 7 || detailObj.status == 9 || detailObj.status == 11}]">{{orderStatus[detailObj.status]}}</div>
                        <!-- <span class="reason" v-if="detailObj.status == 7">
                            退款原因：{{detailObj.reason}}
                        </span> -->
                    </div>
                    <div :class="classNames+ '_content_item'">
                        <div :class="classNames+ '_content_item_label'">收益状态</div>
                        <div v-if="detailObj.income_status" :class="[classNames + '_statur_state',classNames+incomeStatus[detailObj.income_status].class]">
                            {{incomeStatus[detailObj.income_status].label}}
                        </div>
                        <!-- <span class="reason" v-if="detailObj.status == 7">
                            退款原因：{{detailObj.reason}}
                        </span> -->
                    </div>
                    <div v-if="staticPath=='/'" :class="classNames+ '_content_item'">
                        <div :class="classNames+ '_content_item_label'">商户类型</div>
                        <div :class="classNames+ '_content_item_con'">{{ extraData.merchant_type_desc || '' }}</div>
                    </div>
                    <div :class="classNames+ '_content_item'">
                        <div :class="classNames+ '_content_item_label'">下单时间</div>
                        <div :class="classNames+ '_content_item_con'">{{detailObj.created_time}}</div>
                    </div>
                    <div v-if="staticPath=='/dd/'" :class="classNames+ '_content_item'">
                        <div :class="classNames+ '_content_item_label'">短信状态</div>
                        <div :class="classNames+ '_content_item_con'">{{sms_status[detailObj.sms_status]}}</div>
                        <span v-if="detailObj.sms_status==3||detailObj.sms_status==2" style="margin-left: 20px;color: #1989FA; cursor: pointer;" @click="retryPut">重新发送</span>

                    </div>
                    <div :class="classNames+ '_content_item'" v-if="showFlag">
                        <div :class="classNames+ '_content_item_label'">备注</div>
                        <div :class="classNames+ '_content_item_con'">
                            <div v-if="remarksFlag" :class="classNames+ '_content_item_inp'">
                                <el-input v-model="remarks" placeholder="请输入备注" class="con-input"/>
                                <div class="oper">
                                    <span @click="cancelEdit('remark_author')" :class="commonName+'_operation_title'">取消</span>
                                    <span @click="sureEdit('remark_author')" :class="commonName+'_operation_title'">确定</span>
                                    <!-- <el-button size="small" @click="cancelEdit('remark_author')">取消</el-button>
                                    <el-button size="small" type="primary" @click="sureEdit('remark_author')">确定</el-button> -->
                                </div>
                            </div>
                            <div :class="classNames+ '_content_item_inp'" v-else >
                                <p class="text">{{detailObj.remark_author}}</p>
                                <p class="edit" @click="opeationRemark('remark_author')">{{ detailObj.remark_author? '修改': '添加'}}</p>
                            </div>
                        </div>
                    </div>
                    <div :class="classNames+ '_content_item'" v-if="czmCanSettleFlag">
                        <div :class="classNames+ '_content_item_label'">CZM分账</div>
                        <div :class="classNames+ '_content_item_con'">{{detailObj.czm_settle_status}}</div>
                    </div>
                    <template v-if="staticPath === '/'">
                        <div :class="classNames+ '_content_item'">
                            <div :class="classNames+ '_content_item_label'">订单属性</div>
                            <div :class="classNames+ '_content_item_con'">{{detailObj.order_attr_name}}</div>
                        </div>
                        <template v-if="showType === 1">
                            <div :class="classNames+ '_content_item'">
                                <div :class="classNames+ '_content_item_label'">广告计划ID</div>
                                <div :class="classNames+ '_content_item_con'">{{detailObj.promotionid}}</div>
                            </div>
                            <div :class="classNames+ '_content_item'">
                                <div :class="classNames+ '_content_item_label'">项目ID</div>
                                <div :class="classNames+ '_content_item_con'">{{detailObj.projectid}}</div>
                            </div>
                        </template>
                        <div :class="classNames+ '_content_item'">
                            <div :class="classNames+ '_content_item_label'">履约状态</div>
                            <div :class="classNames+ '_content_item_con'">{{detailObj.delivery_status_name}}</div>
                        </div>
                        <div :class="classNames+ '_content_item'">
                            <div :class="classNames+ '_content_item_label'" style="width: 90px;">履约完成时间</div>
                            <div :class="classNames+ '_content_item_con'" style="margin-right: 20px;">{{detailObj.delivery_time}}</div>
                        </div>
                    </template>
                </div>
                <div :class="classNames+ '_content'">
                    <div :class="classNames+ '_content_title'">购买信息</div>
                    <div :class="classNames+ '_content_item'">
                        <div :class="classNames+ '_content_item_label'">购买课程</div>
                        <div :class="classNames+ '_content_item_class'">
                            <img :src="detailObj.product.cover" alt=""/>
                            <div :class="[classNames+ '_content_item_con', classNames+ '_content_item_class_text']">
                                <p>{{detailObj.product.title}}</p>
                                <p>￥{{detailObj.product.price}}</p>
                            </div>
                        </div>
                    </div>
                      <div :class="classNames+ '_content_item'" v-if="detailObj.free_products && detailObj.free_products.length>0">
                        <div :class="classNames+ '_content_item_label'">赠送课程</div>
                        <div class="content-item-right">
                             <div :class="classNames+ '_content_item_class'" v-for="(item,k) in detailObj.free_products" :key="k">
                            <img :src="item.cover" alt=""/>
                            <div :class="[classNames+ '_content_item_con', classNames+ '_content_item_class_text']">
                                <p>{{item.title}}</p>
                                <p>￥{{item.price}}</p>
                            </div>
                        </div>
                        </div>
                       
                    </div>
                    <div :class="classNames+ '_content_item'">
                        <div :class="classNames+ '_content_item_label'">支付金额</div>
                        <div :class="[classNames + '_content_item_con']">￥{{detailObj.pay_amount}}</div>
                    </div>
					<div :class="classNames+ '_content_item'">
					    <div :class="classNames+ '_content_item_label'">购买份数</div>
					    <div :class="[classNames + '_content_item_con']">{{detailObj.number}}</div>
					</div>
                    <div :class="classNames+ '_content_item'">
                        <div :class="classNames+ '_content_item_label'" style="line-height: 36px">购买人</div>
                        <div v-if="detailObj.user_information" :class="[classNames + '_content_item_con', classNames+ '_content_item_pay']">
                            <img :src="detailObj.user_information.avatar_url" alt="" v-if="detailObj.user_information.avatar_url">
                            <div class="pay_name">{{detailObj.user_information.nickname}}</div>
                        </div>
                    </div>
                    <div :class="classNames+ '_content_item'">
                        <div :class="classNames+ '_content_item_label'">订单来源</div>
                        <div :class="classNames+ '_content_item_con'">{{detailObj.scene_value}}</div>
                    </div>
                    <div :class="classNames+ '_content_item'">
                        <div :class="classNames+ '_content_item_label'">支付时间</div>
                        <div :class="classNames+ '_content_item_con'">{{detailObj.pay_time}}</div>
                    </div>
                    <div :class="classNames+ '_content_item'">
                        <div :class="classNames+ '_content_item_label'">交易单号</div>
                        <div :class="classNames+ '_content_item_con'">{{detailObj.trade_no}}</div>
                    </div>
                    <template v-if="staticPath === '/' || staticPath === '/ks/'">
                        <div :class="classNames+ '_content_item'">
                            <div :class="classNames+ '_content_item_label'">购买手机号</div>
                            <div :class="classNames+ '_content_item_con'">{{detailObj.user_information.phone}}</div>
                        </div>
                        <div :class="classNames+ '_content_item'">
                            <div :class="classNames+ '_content_item_label'">授权手机号</div>
                            <div :class="classNames+ '_content_item_con'">{{detailObj.user_information.user_phone}}</div>
                        </div>
                    </template>
                    <div :class="classNames+ '_content_item'" v-else>
                        <div :class="classNames+ '_content_item_label'">手机号</div>
                        <div :class="classNames+ '_content_item_con'">{{detailObj.user_information.phone}}</div>
                    </div>
					<div :class="classNames+ '_content_item'">
					    <div :class="classNames+ '_content_item_label'">课程素材</div>
					    <div :class="classNames+ '_content_item_con'">
							<template v-if="detailObj.material_extract_status == 1">已提取</template>
							<template v-if="detailObj.material_extract_status == 2">未提取</template>
							<template v-if="detailObj.material_extract_status == 3">无</template>
						</div>
					</div>
                    <div :class="classNames+ '_content_item'" v-if="staticPath === '/sph/'">
					    <div :class="classNames+ '_content_item_label'">订单备注</div>
					    <div :class="[classNames + '_content_item_con']">{{ extraData.sph_customer_notes }}</div>
					</div>
                    <div :class="classNames+ '_content_item'" v-if="staticPath === '/'">
					    <div :class="classNames+ '_content_item_label'">规格</div>
					    <div :class="[classNames + '_content_item_con']">{{handleSpecArray(detailObj.spec_array)}}</div>
					</div>
                </div>
                <div :class="classNames+ '_content'">
                    <div :class="classNames+ '_content_title'">收货地址</div>
                    <div :class="classNames+ '_content_item'">
                        <div :class="classNames+ '_content_item_label'">收货人</div>
                        <div :class="classNames+ '_content_item_con'">{{detailObj.user_information.name}}</div>
                    </div>
                    <div :class="classNames+ '_content_item'">
                        <div :class="classNames+ '_content_item_label'">手机号</div>
                        <div :class="classNames+ '_content_item_con'">{{detailObj.user_information.address_phone}}</div>
                    </div>
                    <div :class="classNames+ '_content_item'">
                        <div :class="classNames+ '_content_item_label'">地址</div>
                        <div :class="classNames+ '_content_item_con'">{{detailObj.user_information.address}}</div>
                    </div>
                </div>
                <div :class="classNames+ '_content'">
                    <div :class="classNames+ '_content_title'">推广明细</div>
                    <div :class="classNames+ '_content_item'">
                        <div :class="classNames+ '_content_item_label'">收益金额</div>
                        <div :class="classNames+ '_content_item_con'">￥{{detailObj.talent_income}}</div>
                        <ddProfitCaption v-if="staticPath=='/dd/'"></ddProfitCaption>
                    </div>
                    <div :class="classNames+ '_content_item'">
                        <div :class="[classNames+ '_content_item_label','lone-width']" style="line-height:36px;">推广人{{ platInfo.value==6 ? '抖音' : platInfo.label}}昵称</div>
                        <div :class="[classNames + '_content_item_con', classNames+ '_content_item_pay']">
                            <img :src="detailObj.talent_avatar_url" alt="" v-if="detailObj.talent_avatar_url">
                            <div v-if="staticPath=='/sph/'" class="pay_name">{{ extraData.sph_commission_nickname }}</div>
                            <div v-else class="pay_name">{{detailObj.talent_name}}</div>
                        </div>
                    </div>
                    <div :class="classNames+ '_content_item'">
                        <div :class="[classNames+ '_content_item_label','lone-width']">达人昵称(微信昵称)</div>
                        <div :class="[classNames + '_content_item_con', classNames+ '_content_item_pay']">
                            <div class="pay_name">{{detailObj.talent_wx_name}}</div>
                        </div>
                    </div>
                    <div :class="classNames+ '_content_item'">
                        <div :class="[classNames+ '_content_item_label','lone-width']">达人账号(手机号)</div>
                        <div :class="[classNames + '_content_item_con', classNames+ '_content_item_pay']">
                            <div class="pay_name">{{detailObj.talent_phone}}</div>
                        </div>
                    </div>
                </div>
                <template v-if="staticPath=='/sph/'">
                    <div :class="classNames+ '_content'">
                        <div :class="classNames+ '_content_title'">收益明细</div>
                        <div :class="classNames+ '_content_item'">
                            <div :class="classNames+ '_content_item_label'">课程方收益</div>
                            <div :class="classNames+ '_content_item_con'">￥{{extraData.author_income}}</div>
                        </div>
                        <div :class="classNames+ '_content_item'">
                            <div :class="classNames+ '_content_item_label'">技术服务费</div>
                            <div :class="classNames+ '_content_item_con'">¥{{extraData.commission_fee}}</div>
                        </div>
                        <div :class="classNames+ '_content_item'">
                            <div :class="classNames+ '_content_item_label'">豆包收益</div>
                            <div :class="classNames+ '_content_item_con'">¥{{extraData.commission_doubao}}</div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div :class="classNames+ '_content'">
                        <div :class="classNames+ '_content_title'">课程收益</div>
                        <div :class="classNames+ '_content_item'">
                            <div :class="classNames+ '_content_item_label'">实际收益</div>
                            <div :class="classNames+ '_content_item_con'">￥{{detailObj.author_income}}</div>
                        </div>
                        <div :class="classNames+ '_content_item'">
                            <div :class="classNames+ '_content_item_label'">下单时间</div>
                            <div :class="classNames+ '_content_item_con'">{{detailObj.created_time}}</div>
                        </div>
                    </div>
                </template>
                <div :class="classNames+ '_content'">
                    <div :class="classNames+ '_content_title'">退款信息</div>
                    <div :class="classNames+ '_content_item'">
                        <div :class="classNames+ '_content_item_label'">申请原因</div>
                        <div :class="classNames+ '_content_item_con'">{{detailObj.reason}}</div>
                    </div>
                    <div :class="classNames+ '_content_item'">
                        <div :class="classNames+ '_content_item_label'">问题描述</div>
                        <div :class="classNames+ '_content_item_con'">{{detailObj.refund_description}}</div>

                    </div>
                </div>
            </el-scrollbar>
        </div>
    </el-drawer>
</template>
<script>
import { mapState,mapActions } from 'vuex'
import { getPlatInfo } from '@/utils/baseUrl.js'

import ddProfitCaption from './ddProfitCaption.vue'

export default {
    components: {
        ddProfitCaption
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        id: {
            type: [Number, String],
            default: ''
        },
        channel_type:{
            type: [Number, String],
            default: ''
        },
        showFlag: {
            type: Boolean,
            default: false
        },
        czmCanSettleFlag: {
            type: Boolean,
            default: false
        },
        showType: {
            type: Number,
            default: 0 // 1广告Id、项目id显示
        },
        extraData: { // 额外数据
            type: Object,
            default: ()=> {
                return {
                    author_income: '0.00',
                    commission_doubao: '0.00',
                    commission_fee: '0.00',
                    merchant_type_desc: '',
                    sph_commission_nickname: ''
                }
            }
        }
    },
    created() {
		this.platInfo = getPlatInfo()
        this.$watch(() => this.value, (news) => {
            if(news) {
                this.loading = true
                this.getOrderDetail()
            }
        })
    },
    data() {
        return {
            direction: 'rtl',
            classNames: 'drawer',
            loading: false,
            detailObj: {
                user_information: {},
                product: {}
            },
            orderStatus: {
                4: '已购买',
                2: '待支付',
                7: '已退款',
                9: '退款中',
                11: '退款申请中'
            },
            incomeStatus:{
                1: {label: '未结算', class: '_content_item_status_error'},
                2: {label: '未结算', class: '_content_item_status_error'},
                3: {label: '已结算', class: '_content_item_status_success'},
                4: {label: '已结算', class: '_content_item_status_success'}
            },
            profitStatus:{
                1: '全部',
                2: '已结算',
                3: '未结算',
                4: '抖音商户',
            },
            sms_status: {
                1: '已发送',
                2: '未发送',
                3: '发送失败'
            },
            remarksFlag: false,
            remarks: '',
			platInfo: {}
        }
    },
    computed: {
        ...mapState(['isLoading'])
    },
    methods: {
        ...mapActions('withdrawal', ['orderDetail', 'orderEdit','retryPutApi']),
        handleClose() {
            this.remarksFlag = false
            this.$emit('input', false)
        },
        async retryPut() {
            let res = await this.retryPutApi({order_id: this.detailObj.order_no,is_send_sms:'Yes'})
            console.log(res,'res');
                this.$message({
                    message: '发送成功',
                    duration: 3000,
                    type: 'success'
                })
           this.getOrderDetail()
        },
        async getOrderDetail() {
            let res = await this.orderDetail({order_id: this.id,channel_type:this.channel_type})
            this.detailObj = res
            this.remarks = res.remark_author
            this.loading = false
            this.$nextTick(() => {
                this.$refs.scrollbar.wrap.scrollTop = 0
                // console.log(, '..this.$refs.scrollbar')
            })
        },
        opeationRemark(name) {
            if(this.detailObj[name]) {
                this.remarks = this.detailObj[name]
            }
            this.remarksFlag = true
        },
        cancelEdit(name) {
            this.remarks = this.detailObj[name] || ''
            this.remarksFlag = false
        },
        async sureEdit(name) {
            // if(this.remarks === '') {
            //     this.$message({
            //         message: '请输入备注内容',
            //         duration: 3000,
            //         type: 'error'
            //     })
            //     return
            // }
            await this.orderEdit({
                order_id: this.detailObj.id,
                remark_author: this.remarks,
                channel_type:this.channel_type
            })
            this.detailObj[name] = this.remarks
            this.remarksFlag = false
            this.$emit('editRmark')
        },
        handleSpecArray(list) {
            if(list && list.length) {
                return list.reduce((pre, item,index) => {
                    if(list.length === 0 || index === list.length - 1) {
                        pre+=item.value
                    } else {
                        pre+=item.value+','
                    }
                    return pre
                }, '')
            }
            return ''
        }
    },
}
</script>
<style lang="less">
    @classNames: drawer;
    .@{classNames}_wrap {
        .el-drawer__body {
            height: 0;
        }
        .el-drawer__header {
            height: 48px;
            span {
                font-size: 20px;
                font-weight: 600;
                color: #37383c;
            }
        }
    }
</style>
<style lang="less" scoped>
    @classNames: drawer;
    .@{classNames} {
        display: flex;
        flex-direction: column;
        height: 100%;
        .@{classNames}_content {
            padding: 20px;
            border-top: 1px solid rgb(243, 244, 249);
            .@{classNames}_content_title {
                font-size: 14px;
                font-weight: 600;
                color: #37383c;
            }
            .@{classNames}_content_item {
                background-color: #fff;
                display: flex;
                margin-top: 20px;
                font-size: 14px;
                .@{classNames}_content_item_label {
                    width: 70px;
                    margin-right: 40px;
                    color: #888a95;
                    flex-shrink: 0;
                    // line-height: 36px;
                    &.lone-width{
                        width: 130px;
                        margin-right: 10px;
                    }
                }
                .@{classNames}_content_item_con {
                    color: #333;
                }
                .@{classNames}_statur_state {
                    min-width: 53px;
                    max-width: 100px;
                    height: 18px;
                    line-height: 18px;
                    border-radius: 10px;
                    font-size: 12px;
                    text-align: center;
                    line-height: 20px;
                    padding: 0 5px;
                    margin-right: 5px;
                    flex-shrink: 0;
                }
                .reason {
                    margin-left: 6px;
                    font-size: 12px;
                    word-break: break-all;
                }
                .@{classNames}_content_item_status_success {
                    border: 1px solid rgb(50, 178, 66);
                    color: rgb(50, 178, 66);
                }
                .@{classNames}_content_item_status_error {
                    color: #888a95;
                    border: 1px solid #888a95;
                }
                .@{classNames}_content_item_class {
                    display: flex;
                    img {
                        width: 120px;
                        height: 90px;
                        border-radius: 8px;
                        margin-right: 15px;
                    }
                    .@{classNames}_content_item_class_text {
                        p {
                            &:not(:first-child) {
                                margin-top: 10px;
                            }
                        }
                    }
                }
                .@{classNames}_content_item_pay {
                    display: flex;
                    align-items: center;
                    img {
                        margin-right: 15px;
                        width: 32px;
                        height: 32px;
                        border-radius: 50%;
                    }
                }
            }
        }
        .@{classNames}_content_item_inp {
            display: flex;
            align-items: center;
            .oper {
                margin-left: 12px;
            }
            .con-input {
                width: 200px;
                height: 32px;
                /deep/.el-input__inner {
                    height: 32px;
                    line-height: 32px;
		        }
            }
            .edit {
                color: #1989FA;
                margin-left: 12px;
                white-space: nowrap;
                cursor: pointer;
            }
            .text {
                word-break: break-all;
            }
        }
    }
    .content-item-right{
        display: flex;
        flex-direction: column;
        .@{classNames}_content_item_class{
            margin-bottom: 10px;
        }
    }
</style>
